import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";
import { catchError, map } from "rxjs/operators";
import { TokenStorageService } from './token-storage.service';
const USER_API = environment.apiUrl;
const TURNAMENT_API = environment.apiUrl + "tournament";
const PICKLEBALL_TOURNAMENT_API = environment.apiUrl + "pickleball-tournament";
const PADEL_TOURNAMENT_API = environment.apiUrl + "padel-tournament";
const TURNAMENT_LOCATION = TURNAMENT_API + "/location";
const TOURNAMENT_PLAYER_API = environment.apiUrl + "tournament-player";
const TOURNAMENT_USERWALLET_API = environment.apiUrl + "userwallet";
const SEARCH_BY_EMAIL = environment.apiUrl + "user?filterByMobile=";
//const CHAT_API = environment.apiUrl="chat/conversations/group/by-tournament/";

const CHAT_DETAILS_API = environment.apiUrl + "chat/conversations/group/by-tournament/";
const CHAT_HISTORY_API = environment.apiUrl + "chat/conversations/";

//http://localhost:4600/api/tournament-player/{{tournamentplayerid}}

@Injectable({
  providedIn: "root",
})
export class TournamentsService {
  authtoken: string;
  private httpOptions;
  constructor(private http: HttpClient, private token: TokenStorageService) {
    this.authtoken = this.token.getToken();
    this.httpOptions = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/json")
        .set('Authorization', `Bearer ${this.authtoken}`)
    };
  }

  getTournamentsChatDetails(id: string, type: string): Observable<any> {
    return this.http.get(CHAT_DETAILS_API + id + "?type=" + type, this.httpOptions);
  }

  getTournamentChatHistory(id: string, query: string): Observable<any> {
    return this.http.get(CHAT_HISTORY_API + id + "/messages?" + query, this.httpOptions);
  }

  getTournamentfilterData(): Observable<any> {
    const apiUrl = `${TURNAMENT_API}/tournamentAppFilters/`;
    return this.http.get(apiUrl);
  }

  getTournamentIds(userId: string): Observable<string[]> {
    const apiUrl = `${TOURNAMENT_PLAYER_API}/player/${userId}`;

    return this.http.get(apiUrl).pipe(
      map((response: any) =>
        response.items.map((item: any) => item.tournamentId)
      ),
      catchError((error: any) => {
        console.error("Error fetching tournament data:", error);
        return [];
      })
    );
  }

  getTtournamentPlayerData(tournamentPlayerData: any): Observable<any> {
    const apiUrl = `${TOURNAMENT_PLAYER_API}`;
    return this.http.post(apiUrl, tournamentPlayerData);
  }

  getTtournamentPlayerDataV2(tournamentPlayerData: any): Observable<any> {
    const apiUrl = `${TOURNAMENT_PLAYER_API}/v2`;
    return this.http.post(apiUrl, tournamentPlayerData);
  }

  getUserwalletData(userwalletdata: any): Observable<any> {
    const apiUrl = `${TOURNAMENT_USERWALLET_API}`;
    return this.http.post(apiUrl, userwalletdata);
  }

  getwithdrawtournamentData(id: any): Observable<any> {
    const apiUrl = `${TOURNAMENT_PLAYER_API}/category/${id}`;
    return this.http.get(apiUrl);
  }
  getwithdrawamount(tournamentPlayerId: any, body: any): Observable<any> {
    const apiUrl = `${TOURNAMENT_PLAYER_API}/${tournamentPlayerId}`;
    return this.http.put(apiUrl, body);
  }
  getPadelWithdrawAmount(tournamentPlayerId: any, body: any): Observable<any> {
    const apiUrl = `${USER_API}padeltournament-player/${tournamentPlayerId}`;
    return this.http.put(apiUrl, body);
  }
  getPickleballWithdrawAmount(tournamentPlayerId: any, body: any): Observable<any> {
    const apiUrl = `${USER_API}pickletournament-player/${tournamentPlayerId}`;
    return this.http.put(apiUrl, body);
  }
  getTournamentMaxPlayerCapacity(tournamentId: string, query: string) {
    const apiUrl = `${TOURNAMENT_PLAYER_API}/v2/capacity-check/${tournamentId}?${query}`;
    return this.http.get(apiUrl);
  }
  getSearchbyEmail(doublePartnerDetails: any): Observable<any> {
    let apiUrl = `${SEARCH_BY_EMAIL}${doublePartnerDetails.mobileNumber}`;
    apiUrl += `&filterByPhoneCode=${doublePartnerDetails.phoneCode}`;
    return this.http.get(apiUrl);
  }

  getTournamentsList() {
    return this.http
      .get("assets/demo/data/tournament.json")
      .toPromise()
      .then((res) => res)
      .then((data) => data);
  }
  getMatchList(userId, query) {
    return this.http.get(TOURNAMENT_PLAYER_API + "/matches/" + userId + query, this.httpOptions);
  }

  // getMatchList(query): Observable<any> {
  //     return this.http.get(TURNAMENT_API + "/v1?" + query);
  // }

  getRankingList() {
    return this.http
      .get("assets/demo/data/ranking.json")
      .toPromise()
      .then((res) => res)
      .then((data) => data);
  }
  getTournamentsListWithoutAuth(query): Observable<any> {
    //console.log("text");
    return this.http.get(TURNAMENT_API + "/v1?" + query);
  }
  getTournamentsListWithAuth(query): Observable<any> {
    return this.http.get(TURNAMENT_API + "?" + query, this.httpOptions);
  }
  getPickleBallTournamentsListWithAuth(query): Observable<any> {
    return this.http.get(PICKLEBALL_TOURNAMENT_API + "?" + query, this.httpOptions);
  }
  getPadelTournamentsListWithAuth(query): Observable<any> {
    return this.http.get(PADEL_TOURNAMENT_API + "?" + query, this.httpOptions);
  }
  getTennisTournamentCanceledPlayers(tournamentId:string) {
    return this.http.get(TURNAMENT_API + '/tournamentrefundcreditreport/' + tournamentId);
  }
  getPickleBallTournamentCanceledPlayers(tournamentId:string) {
    return this.http.get(PICKLEBALL_TOURNAMENT_API + '/tournamentrefundcreditreport/' + tournamentId);
  }
  getPadelTournamentCanceledPlayers(tournamentId:string) {
    return this.http.get(PADEL_TOURNAMENT_API + '/tournamentrefundcreditreport/' + tournamentId);
  }
  getTournamentsDetails(id: string) {
    //return this.http.get<any>(TURNAMENT_API + "/v1?" + "/{id}");

    return this.http.get<any>(`${TURNAMENT_API}/${id}`);
  }
  /* Tournament cat based age part API start */
  getTournamentscat(id: string): Observable<any> {
    const CATLIST_API =
      USER_API + `tournament-category/category/${id}?getMatchtype=true`;
    return this.http.get<any>(CATLIST_API);
  }
  getTournamentscatUser(id: string, userId): Observable<any> {
    const CATLIST_API =
      USER_API + `tournament-category/admin/category/${id}?getMatchtype=true&userId=${userId}`;
    return this.http.get<any>(CATLIST_API);
  }
  getPickleBallTournamentscatUser(id: string, userId): Observable<any> {
    const CATLIST_API =
      USER_API + `pickletournament-category/admin/category/${id}?getMatchtype=true&userId=${userId}`;
    return this.http.get<any>(CATLIST_API);
  }
  getPadelTournamentscatUser(id: string, userId): Observable<any> {
    const CATLIST_API =
      USER_API + `padeltournament-category/admin/category/${id}?getMatchtype=true&userId=${userId}`;
    return this.http.get<any>(CATLIST_API);
  }
  getCatbasedAge(
    id: string,
    selectedMatchType: string,
    tournamentCategoryId: string,
    userole?: string,
    userId?: string
  ): Observable<any> {
    const CATBASED_AGEAPI =
      USER_API +
      `tournament-category/category/${id}?getAgeGroup=true&matchtype=`;
    const apiUrl = `${CATBASED_AGEAPI}${selectedMatchType}&tournamentCategoryId=${tournamentCategoryId}&userId=${userId}&role=${userole}`;
    return this.http.get<any>(apiUrl);
  }

  getPickleBallCatbasedAge(
    id: string,
    selectedMatchType: string,
    tournamentCategoryId: string,
    userole?: string,
    userId?: string
  ): Observable<any> {
    const CATBASED_AGEAPI =
      USER_API +
      `pickletournament-category/category/${id}?getAgeGroup=true&matchtype=`;
    const apiUrl = `${CATBASED_AGEAPI}${selectedMatchType}&tournamentCategoryId=${tournamentCategoryId}&userId=${userId}&role=${userole}`;
    return this.http.get<any>(apiUrl);
  }

  getPadelCatbasedAge(
    id: string,
    selectedMatchType: string,
    tournamentCategoryId: string,
    userole?: string,
    userId?: string
  ): Observable<any> {
    const CATBASED_AGEAPI =
      USER_API +
      `padeltournament-category/category/${id}?getAgeGroup=true&matchtype=`;
    const apiUrl = `${CATBASED_AGEAPI}${selectedMatchType}&tournamentCategoryId=${tournamentCategoryId}&userId=${userId}&role=${userole}`;
    return this.http.get<any>(apiUrl);
  }
  getRestrictCatbasedAge(
    id: string,
    selectedMatchType: string,
    tournamentCategoryId: string
  ): Observable<any> {
    const CATBASED_AGEAPI =
      USER_API +
      `tournament-category/category/${id}?getAgeGroup=true&restrictedPlayer=true&matchtype=`;
    const apiUrl = `${CATBASED_AGEAPI}${selectedMatchType}&tournamentCategoryId=${tournamentCategoryId}`;
    return this.http.get<any>(apiUrl);
  }

  getAcademyTournamentsList(query): Observable<any> {
    //console.log("text");
    return this.http.get(TURNAMENT_API + "/v1?" + query);
  }

  /* Tournament cat based age part API End */

  getTournamentsLocations() {
    //return this.http.get<any>(TURNAMENT_API + "/v1?" + "/{id}");

    return this.http.get<any>(`${TURNAMENT_LOCATION}`);
  }

  // updateTournaments(id, careerData): Observable<any> {
  //     return this.http.put(USER_API + 'career/' + id, careerData);
  // }
  updateTournament(id, data): Observable<any> {
    return this.http.put(TURNAMENT_API + "/" + id, data);
  }
  addTournaments(careerData): Observable<any> {
    return this.http.post(USER_API + "career", careerData);
  }

  getTournaments(id): Observable<any> {
    return this.http.get(USER_API + "career/" + id);
  }
  addingTournament(tournamnetdata) {
    return this.http.post(USER_API + "tournament", tournamnetdata);
  }
  addingPickleBallTournament(tournamnetdata) {
    return this.http.post(PICKLEBALL_TOURNAMENT_API, tournamnetdata);
  }
  addingPadelTournament(tournamnetdata) {
    return this.http.post(PADEL_TOURNAMENT_API, tournamnetdata);
  }
  addingTournamentCategory(categorytdata) {
    return this.http.post(USER_API + "tournament-category", categorytdata);
  }
  addingPickleBallTournamentCategory(categorytdata) {
    return this.http.post(USER_API + "pickleball-tournament/tournament-category", categorytdata);
  }
  addingPadelTournamentCategory(categorytdata) {
    return this.http.post(USER_API + "padel-tournament/tournament-category", categorytdata);
  }
  getTournament(id): Observable<any> {
    return this.http.get(USER_API + "tournament" + id);
  }
  getTournamentDetailsByID(id): Observable<any> {
    return this.http.get(USER_API + "tournament/" + id);
  }
  getPickleBallTournamentDetailsByID(id): Observable<any> {
    return this.http.get(PICKLEBALL_TOURNAMENT_API + "/" + id);
  }
  getPadelTournamentDetailsByID(id): Observable<any> {
    return this.http.get(PADEL_TOURNAMENT_API + "/" + id);
  }
  addlogo(logo): Observable<any> {
    return this.http.post(USER_API + "tournament-sponsor-logo", logo);
  }
  addPickleBallTournamentlogo(logo): Observable<any> {
    return this.http.post(USER_API + "pickletournament-sponsor-logo", logo);
  }
  addPadelTournamentlogo(logo): Observable<any> {
    return this.http.post(USER_API + "padeltournament-sponsor-logo", logo);
  }
  getlogo(id): Observable<any> {
    return this.http.get(USER_API + "tournament-sponsor-logo" + id);
  }
  getPickleBallTournamentlogo(id): Observable<any> {
    return this.http.get(USER_API + "pickletournament-sponsor-logo" + id);
  }
  getPadelTournamentlogo(id): Observable<any> {
    return this.http.get(USER_API + "padeltournament-sponsor-logo" + id);
  }
  updatetournament(id, data): Observable<any> {
    return this.http.put(USER_API + "tournament/" + id, data);
  }
  generateTournamentReport(query: string) {
    return this.http.get(USER_API + "tournament/report/csv" + query);
  }
  updatePickleBallTournament(id, data): Observable<any> {
    return this.http.put(PICKLEBALL_TOURNAMENT_API + "/" + id, data);
  }
  updatePadelTournament(id, data): Observable<any> {
    return this.http.put(PADEL_TOURNAMENT_API + "/" + id, data);
  }
  updatecategory(id, data): Observable<any> {
    return this.http.put(USER_API + "tournament-category/" + id, data);
  }
  updatelogo(id, data): Observable<any> {
    return this.http.put(USER_API + "tournament-sponsor-logo/" + id, data);
  }
  updatePickleBallTournamentlogo(id, data): Observable<any> {
    return this.http.put(USER_API + "pickletournament-sponsor-logo/" + id, data);
  }
  updatePadelTournamentlogo(id, data): Observable<any> {
    return this.http.put(USER_API + "padeltournament-sponsor-logo/" + id, data);
  }
  deletelogo(id): Observable<any> {
    return this.http.delete(USER_API + "tournament-sponsor-logo" + id);
  }
  deletePickleBallTournamentlogo(id): Observable<any> {
    return this.http.delete(USER_API + "pickletournament-sponsor-logo" + id);
  }
  deletePadelTournamentlogo(id): Observable<any> {
    return this.http.delete(USER_API + "padeltournament-sponsor-logo" + id);
  }
  getTournamentPlayerList(id, query): Observable<any> {
    return this.http.get(USER_API + "tournament-player/" + id, query);
  }

  getTournamentList(query): Observable<any> {
    return this.http.get(USER_API + "tournament" + query);
  }

  getPlayerTournamentList(query): Observable<any> {
    return this.http.get(USER_API + "tournament-player/mytournaments/" + query);
  }

  getPlayerAcheivement(query): Observable<any> {
    return this.http.get(USER_API + "tournamentscore/certificate/" + query);
  }


  getTournamentCategory(id, query): Observable<any> {
    return this.http.get(
      USER_API + "tournament-category/category/" + id + "?" + query
    );
  }

  getTournamentCategoryV2Old(id): Observable<any> {
    return this.http.get(
      USER_API + "tournament-category/tournament/" + id
    );
  }

  getTournamentCategoryV2(id): Observable<any> {
    return this.http.get(
      USER_API + "tournament-category/eligible-agegroups/" + id
    );
  }

  getPickleBallTournamentCategory(id, query): Observable<any> {
    return this.http.get(
      USER_API + "pickletournament-category/category/" + id + "?" + query
    );
  }

  getPickleBallTournamentCategoryV2(id): Observable<any> {
    return this.http.get(
      USER_API + "pickletournament-category/tournament/" + id
    );
  }

  getPadelTournamentCategory(id, query): Observable<any> {
    return this.http.get(
      USER_API + "padeltournament-category/category/" + id + "?" + query
    );
  }

  getPadelTournamentCategoryV2(id): Observable<any> {
    return this.http.get(
      USER_API + "padeltournament-category/tournament/" + id
    );
  }

  getTournamentPlayers(id, query): Observable<any> {
    return this.http.get(USER_API + "tournament-player/" + id + "?" + query);
  }
  getPickleBallTournamentPlayers(id, query): Observable<any> {
    return this.http.get(USER_API + "pickletournament-player/" + id + "?" + query);
  }
  getPadelTournamentPlayers(id, query): Observable<any> {
    return this.http.get(USER_API + "padeltournament-player/" + id + "?" + query);
  }
  getSkillChart() {
    return this.http.get(USER_API + "tournamentdraw/skillchart");
  }
  getCompareSkillList(query): Observable<any> {
    return this.http.get(USER_API + "tournamentdraw/compareskills?" + query);
  }
  getMatchSkillist(query): Observable<any> {
    return this.http.get(
      USER_API + "tournamentdraw/profileskillhistory?" + query
    );
  }

  getListOfPlayers(id, query): Observable<any> {
    return this.http.get(
      USER_API + "tournament-player/playerData/" + id + query
    );
  }

  getListOfPickleballTournamentPlayers(id, query): Observable<any> {
    return this.http.get(
      USER_API + "pickletournament-player/playerData/" + id + query
    );
  }

  getListOfPadelTournamentPlayers(id, query): Observable<any> {
    return this.http.get(
      USER_API + "padeltournament-player/playerData/" + id + query
    );
  }

  tournamentIncomeHistory(id, query): Observable<any> {
    return this.http.get(USER_API + "tournament/allTotal/" + id + "?" + query);
  }
  tournamentCategoryList(id): Observable<any> {
    return this.http.get(USER_API + "tournament/tournamentCategory/" + id);
  }

  private categoryArray = new BehaviorSubject<string>("");
  castCategoryArray = this.categoryArray.asObservable();

  sendCategory(newArray) {
    this.categoryArray.next(newArray);
  }

  getCategory() {
    let cat = this.categoryArray.getValue();
    return cat;
  }
  saveDraw(id, data): Observable<any> {
    return this.http.put(USER_API + "tournament-category/publish/" + id, data);
  }
  saveRoundRobinDraw(id, data): Observable<any> {
    return this.http.put(USER_API + "rounrobin-tournament-category/publish/" + id, data);
  }
  getRoundRobinTournamentCategoryStatus(id): Observable<any> {
    return this.http.get(USER_API + "rounrobin-tournament-category/" + id + "/status");
  }
  resetRoundRobinTournamentCategory(query): Observable<any> {
    return this.http.get(USER_API + "rounrobin-tournament-category/v1/reset?" + query);
  }
  getDrawResult(query) {
    return this.http.get(USER_API + "tournament-category/result?" + query);
  }
  getRoundRobinDrawResult(query): Observable<any> {
    return this.http.get<any>(USER_API + "rounrobin-tournament-category/result?" + query);
  }

  savePickleBallDraw(id, data): Observable<any> {
    return this.http.put(USER_API + "pickletournament-category/publish/" + id, data);
  }
  getPickleBallDrawResult(query) {
    return this.http.get(USER_API + "pickletournament-category/result?" + query);
  }

  savePadelDraw(id, data): Observable<any> {
    return this.http.put(USER_API + "padeltournament-category/publish/" + id, data);
  }
  getPadelDrawResult(query) {
    return this.http.get(USER_API + "padeltournament-category/result?" + query);
  }

  ///deleteCategory from player-list
  deleteCategory(categoryId, data): Observable<any> {
    return this.http.put(
      USER_API + "tournament-category/refund/" + categoryId,
      data
    );
  }
  ////

  deletePickleBallCategory(categoryId, data): Observable<any> {
    return this.http.put(
      USER_API + "pickletournament-category/refund/" + categoryId,
      data
    );
  }

  deletePadelCategory(categoryId, data): Observable<any> {
    return this.http.put(
      USER_API + "padeltournament-category/refund/" + categoryId,
      data
    );
  }

  deleteAllTournamentCategories(tournamentId: string, data) {
    return this.http.put(USER_API + "tournament-category/" + tournamentId, data);
  }

  deleteAllPickleBallTournamentCategories(tournamentId: string, data) {
    return this.http.put(USER_API + "pickletournament-category/" + tournamentId, data);
  }

  deleteAllPadelTournamentCategories(tournamentId: string, data) {
    return this.http.put(USER_API + "padeltournament-category/" + tournamentId, data);
  }

  findBySlug(): Observable<any> {
    return this.http.get(USER_API + "tournament-category/slug-category");
  }

  findByPickleBallSlug(): Observable<any> {
    return this.http.get(USER_API + "pickletournament-category/slug-category");
  }

  findByPadelSlug(): Observable<any> {
    return this.http.get(USER_API + "padeltournament-category/slug-category");
  }

  getTotalTournamentPlayerCount(tournamentId) {
    return this.http.get(USER_API + "tournament-player/getPlayercount/" + tournamentId);
  }

  tournamentscore(query) {
    return this.http.get(USER_API + "leaderboardscore/score/v1?" + query);
  }
  tournamentPlayerscore(userId, query) {
    return this.http.get(USER_API + "tournamentscore/playerscore/" + userId + "?" + query);
  }

  tournamentRankingHistoryPlayerscore(userId, query) {
    return this.http.get(USER_API + "tournamentscore/playerscore/history/" + userId + "?" + query);
  }

  tournamentLeaderPlayerscore(userId, query) {
    return this.http.get(USER_API + "leaderboardscore/playerscore/" + userId + "?" + query);
  }

  tournamentPlayerLatestscore(userId) {
    return this.http.get(USER_API + "tournamentscore/playerlatestscore/" + userId);
  }
  addTournamentPlayer(tournamentplayerdata): Observable<any> {
    return this.http.post(USER_API + "tournament-player/v1", tournamentplayerdata);
  }
  addPickleBallTournamentPlayer(tournamentplayerdata): Observable<any> {
    return this.http.post(USER_API + "pickletournament-player/v1admin", tournamentplayerdata);
  }
  addPadelTournamentPlayer(tournamentplayerdata): Observable<any> {
    return this.http.post(USER_API + "padeltournament-player/v1", tournamentplayerdata);
  }
  gettournamentLeaderCategory() {
    return this.http.get(USER_API + "leaderboardscore/scorecategories");
  }

  gettournamentLeaderCategoryV2() {
    return this.http.get(USER_API + "leaderboardscore/v1/scorecategories");
  }

  getTournamentDetailsByIDForCertificate(id): Observable<any> {
    return this.http.get(USER_API + "tournament/certificate/" + id);
  }

  contestLeaderboard(query) {
    return this.http.get(USER_API + "contestleaderboardscore/score/v1?" + query);
  }
  userContestPlayerscore(userId, query) {
    return this.http.get(USER_API + "user-contest/playerscore/" + userId + "?" + query);
  }

  getMumbaiTournamentsDetails() {
    //return this.http.get<any>(TURNAMENT_API + "/v1?" + "/{id}");

    return this.http.get<any>(`${TURNAMENT_API}/report`);
  }

  getTournamentsReportDetails() {
    return this.http.get<any>(`${TURNAMENT_API}/report/export-data`);
  }

  getTournamentDeleteRequests(query): Observable<any> {
    return this.http.get(TURNAMENT_API + "?" + query);
  }
  getPickleBallTournamentDeleteRequests(query): Observable<any> {
    return this.http.get(PICKLEBALL_TOURNAMENT_API + "?" + query);
  }
  getPadelTournamentDeleteRequests(query): Observable<any> {
    return this.http.get(PADEL_TOURNAMENT_API + "?" + query);
  }


  getAcademyFiltersByStateCity(query): Observable<any> {
  return this.http.get( environment.apiUrl + '/academy/academyFilters' + query);
}
}
